import React, { useEffect, useState } from "react";
import { useInterval } from "@/utils";

interface CountdownProps {
  onFinish: () => void;
}

type Props = CountdownProps;

const CountdownTimer: React.FC<Props> = React.memo(({ onFinish }) => {
  const [counter, setCounter] = useState(3);

  useInterval(() => {
    setCounter(c => c - 1);
  }, 1000);

  useEffect(() => {
    if (counter === 0) {
      onFinish();
    }
  }, [counter]);

  return (
    <div className="fixed inset-0 w-screen h-screen z-[9999] flex justify-center items-center bg-black/30 pointer-events-none">
      <span
        className="text-white text-[20vw] font-bold select-none"
        style={{
          WebkitTextFillColor: "transparent",
          WebkitTextStroke: "8px white",
        }}
      >
        {counter}
      </span>
    </div>
  );
});

export default CountdownTimer;
